import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradingCompetitionKeys } from './tradingCompetition.keys';
import { registerToTradingCompetition } from './tradingCompetition.service';
export const useRegisterToTradingCompetition = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ subdomain, tradingCompetitionId, data, }) => {
            return registerToTradingCompetition(subdomain, tradingCompetitionId, data);
        },
        onSuccess: async (_, { subdomain, tradingCompetitionId }) => {
            await queryClient.invalidateQueries({
                queryKey: tradingCompetitionKeys.isUserRegistered(subdomain, tradingCompetitionId),
            });
        },
    });
};
